import { createTheme } from '@mui/material/styles';
import { COLORS } from '../utils/constants';

const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary,
    },
    secondary: {
      main: COLORS.secondary,
    },
  },
  typography: {
    fontFamily: 'Satoshi, Arial, sans-serif',
    h1: {
      fontFamily: 'Antonio, sans-serif',
    },
    h2: {
      fontFamily: 'Antonio, sans-serif',
    },
    h3: {
      fontFamily: 'Antonio, sans-serif',
    },
    h4: {
      fontFamily: 'Antonio, sans-serif',
    },
    h5: {
      fontFamily: 'Antonio, sans-serif',
    },
    h6: {
      fontFamily: 'Antonio, sans-serif',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Satoshi, Arial, sans-serif',
        },
      },
    },
  },
});

export default theme; 